import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  AuthService,
  BalanceQuery,
  Card,
  CardQuery,
  MemberCard,
  MemberCardQuery,
  MemberDetails,
  MemberQuery,
  NotificationCenterQuery,
  NotificationCenterService,
  config,
} from '@fgb/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-mobile-nav-menu',
  templateUrl: './mobile-nav-menu.component.html',
  styleUrls: ['./mobile-nav-menu.component.scss'],
})
export class MobileNavMenuComponent implements OnInit, OnDestroy {
  memberDetails$: Observable<MemberDetails | undefined>;
  memberCard$: Observable<MemberCard | undefined>;
  selectedMember: string;
  cards$: Observable<Card[]>;
  unseenNotificationCount$: Observable<number>;
  ecash$: Observable<number | undefined>;
  population = Populations;
  isMenuOpen = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private memberQuery: MemberQuery,
    private memberCardQuery: MemberCardQuery,
    private cardQuery: CardQuery,
    private notificationService: NotificationCenterService,
    private notificationQuery: NotificationCenterQuery,
    private balanceQuery: BalanceQuery
  ) { }
  private routerSubscription: Subscription;
  public isCollapsed = true;

  ngOnInit() {
    this.initMemberAccounts();
    this.routerSubscription = this.router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        tap(() => { this.isCollapsed = true; this.isMenuOpen = false; })
      )
      .subscribe();
    this.unseenNotificationCount$ = this.notificationQuery.unseenNotificationsCount$;
  }

  initMemberAccounts() {
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.memberCard$ = this.memberCardQuery.selectCurrentCard();
    this.cards$ = this.cardQuery.selectCards();
    this.selectedMember = this.memberQuery.getUserContext().memberId;
    this.ecash$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  logout() {
    this.authService
      .logout()
      .toPromise()
      .then(() => this.router.navigate(['/login']));
  }

  loginWithCard(memberId: string) {
    this.authService.switchUser(memberId).toPromise();
  }

  toggleNotificationCenter(open: boolean) {
    this.notificationService.updateIsOpen(open);
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }
}
